import { render, staticRenderFns } from "./Character.vue?vue&type=template&id=d4d73be8&lang=html"
import script from "./Character.vue?vue&type=script&lang=js"
export * from "./Character.vue?vue&type=script&lang=js"
import style0 from "./Character.vue?vue&type=style&index=0&id=d4d73be8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports